"use client";

import { ExternalButton } from "@sharedComponents/buttons";

import { BYSTADIUM_MARKETING_URL } from "@stadium/helpers/app-routes";

import styles from "./main.module.scss";

const Custom404 = ({ backToHomeHref }) => {
  return (
    <div className={styles.NotFoundWrapper}>
      <section className={styles.textCenter}>
        <div className={styles.container}>
          <div className={styles.largeTextNumber}>404</div>
          <div className={styles.pageNotFoundHead}>PAGE NOT FOUND</div>
          <p className={styles.notFound}>We’re not able to find what you were looking for.</p>
          <ExternalButton href={backToHomeHref || BYSTADIUM_MARKETING_URL} styleType="link">
            BACK TO HOME
          </ExternalButton>
        </div>
      </section>
    </div>
  );
};

export default Custom404;
